import { cn } from "@/infrastructure/lib/utils";

interface SpinnerProps {
  className?: string;
}

export function Spinner({ className }: SpinnerProps) {
  return (
    <div 
      className={cn(
        "animate-spin rounded-full border-2 border-t-2 border-gray-200 border-t-blue-500 h-5 w-5",
        className
      )}
    />
  );
}
